import styled from 'styled-components';
import MuiIconButton from '@mui/material/IconButton';
import { scrollbarStyle } from '../../util/scrollbarStyle';
import { readableColor } from 'polished';
export const NavContent = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;

  ${scrollbarStyle}

  &.no-show-scroll {
    ::-webkit-scrollbar {
      width: 0;
    }
  }

  @media (max-width: 425px) {
    &::-webkit-scrollbar {
      width: 0;
    }
  }
`;
export const IconButton = styled(MuiIconButton)`
  padding: 7px !important;
  outline: none;

  &:hover,
  &:focus {
    outline: none;
  }
`;